export enum DisplayGroupSortBy {
  title = 'title',
  ownerName = 'ownerName',
  ownerEmail = 'ownerEmail',
  createdAt = 'createdAt',
  plusExpiresAt = 'plusExpiresAt'
}

export enum DisplayGroupSortOrder {
  asc = 'asc',
  desc = 'desc'
}
